import { ActionCreator, on, ReducerTypes } from '@ngrx/store';
import { PatrimoineHierarchieTemplateGeneratedActions } from '@get/store/actions';
import { PatrimoineHierarchieTemplateState } from '@get/store/states';
import { Dictionary } from '@ngrx/entity';
import { PatrimoineHierarchieTemplateEntityState } from '@get/api-interfaces';

export const patrimoineHierarchieTemplateReducersGeneratedFunctions: ReducerTypes<PatrimoineHierarchieTemplateState.IState, readonly ActionCreator[]>[] = [
  on(PatrimoineHierarchieTemplateGeneratedActions.getOnePatrimoineHierarchieTemplate, (state: PatrimoineHierarchieTemplateState.IState) => setLoadingsState(state, true)),
  on(PatrimoineHierarchieTemplateGeneratedActions.getManyPatrimoineHierarchieTemplates, (state: PatrimoineHierarchieTemplateState.IState) => setLoadingsState(state, true)),
  on(PatrimoineHierarchieTemplateGeneratedActions.upsertOnePatrimoineHierarchieTemplate, (state: PatrimoineHierarchieTemplateState.IState) => setLoadingsState(state, true)),

  on(PatrimoineHierarchieTemplateGeneratedActions.upsertManyPatrimoineHierarchieTemplatesSuccess, (state: PatrimoineHierarchieTemplateState.IState, { patrimoineHierarchieTemplates }) =>
    PatrimoineHierarchieTemplateState.adapter.upsertMany(patrimoineHierarchieTemplates, setLoadingsState(state, false))
  ),
  on(PatrimoineHierarchieTemplateGeneratedActions.deleteOnePatrimoineHierarchieTemplate, (state: PatrimoineHierarchieTemplateState.IState) => setLoadingsState(state, true)),
  on(PatrimoineHierarchieTemplateGeneratedActions.deleteOnePatrimoineHierarchieTemplateSuccess, (state: PatrimoineHierarchieTemplateState.IState, { idPatrimoineHierarchieTemplate }) =>
    PatrimoineHierarchieTemplateState.adapter.removeOne(idPatrimoineHierarchieTemplate, setLoadingsState(state, false))
  ),
  on(PatrimoineHierarchieTemplateGeneratedActions.clearActivesPatrimoineHierarchieTemplates, (state: PatrimoineHierarchieTemplateState.IState) => ({ ...state, actives: [] })),
  on(PatrimoineHierarchieTemplateGeneratedActions.addManyActivesPatrimoineHierarchieTemplates, (state: PatrimoineHierarchieTemplateState.IState, { idPatrimoineHierarchieTemplates }) => ({
    ...state,
    actives: state.actives.concat(idPatrimoineHierarchieTemplates)
  })),
  on(PatrimoineHierarchieTemplateGeneratedActions.deleteOneActivePatrimoineHierarchieTemplate, (state: PatrimoineHierarchieTemplateState.IState, { idPatrimoineHierarchieTemplate }) => ({
    ...state,
    actives: state.actives.filter(id => id !== idPatrimoineHierarchieTemplate)
  })),

  on(PatrimoineHierarchieTemplateGeneratedActions.clearPatrimoineHierarchieTemplates, () => PatrimoineHierarchieTemplateState.initialState),

  on(
    PatrimoineHierarchieTemplateGeneratedActions.addManySocietePatrimoineHierarchieSuccess,
    (state: PatrimoineHierarchieTemplateState.IState, { idPatrimoineHierarchieTemplate, idSocietePatrimoineHierarchies }) => {
      if (!state.entities[idPatrimoineHierarchieTemplate]) {
        return state;
      }
      const societePatrimoineHierarchies = (state.entities[idPatrimoineHierarchieTemplate]?.societePatrimoineHierarchies as number[]) || [];
      return {
        ...state,
        entities: {
          ...state.entities,
          [idPatrimoineHierarchieTemplate]: {
            ...state.entities[idPatrimoineHierarchieTemplate],
            societePatrimoineHierarchies: societePatrimoineHierarchies.concat(
              idSocietePatrimoineHierarchies.filter(id => societePatrimoineHierarchies.indexOf(id) < 0)
            )
          }
        }
      };
    }
  ),

  on(
    PatrimoineHierarchieTemplateGeneratedActions.deleteManySocietePatrimoineHierarchieSuccess,
    (state: PatrimoineHierarchieTemplateState.IState, { idSocietePatrimoineHierarchies, idPatrimoineHierarchieTemplates }) => {
      return {
        ...state,
        entities: {
          ...state.entities,
          ...idPatrimoineHierarchieTemplates.reduce((entities, idPatrimoineHierarchieTemplate) => {
            if (!state.entities[idPatrimoineHierarchieTemplate]?.societePatrimoineHierarchies) {
              return entities;
            }
            entities[idPatrimoineHierarchieTemplate] = {
              ...state.entities[idPatrimoineHierarchieTemplate],
              societePatrimoineHierarchies: (state.entities[idPatrimoineHierarchieTemplate]?.societePatrimoineHierarchies as number[])?.filter(
                (idSocietePatrimoineHierarchie: number) => !idSocietePatrimoineHierarchies.some((id: number) => id === idSocietePatrimoineHierarchie)
              )
            } as PatrimoineHierarchieTemplateEntityState;
            return entities;
          }, {} as Dictionary<PatrimoineHierarchieTemplateEntityState>)
        }
      };
    }
  ),
];

export function setLoadingsState(
  state: PatrimoineHierarchieTemplateState.IState,
  isLoading: boolean,
  isLoaded: boolean = true
): PatrimoineHierarchieTemplateState.IState {
  return { ...state, isLoaded, isLoading };
}
